"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/PhoneInputController.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _hookForm = require('shared/services/validation/hookForm');

var _PhoneInput = require('./PhoneInput'); var _PhoneInput2 = _interopRequireDefault(_PhoneInput);












const PhoneInputController = ({
  control,
  name,
  hasError,
  onType,
  onLeave,
  ...props
}) => (
  _react2.default.createElement(_hookForm.Controller, {
    control: control,
    name: name,
    render: ({ field, fieldState }) => (
      _react2.default.createElement(_PhoneInput2.default, {
        ...props,
        value: field.value  || '',
        onChange: (value) => {
          _optionalChain([onType, 'optionalCall', _ => _()])
          field.onChange(value)
        },
        onBlur: () => {
          _optionalChain([onLeave, 'optionalCall', _2 => _2(field.value  || '')])
          field.onBlur()
        },
        hasError: _nullishCoalesce(hasError, () => ( !!fieldState.error)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      )
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
  )
  )

exports. default = PhoneInputController
